import CONSTANT from "../constant/constant";
import { leaveOverviewConstants } from "../constant/leaveOverview.constants";

export const initialState = {
    listOverview: [],
    errorCode: "",
    successCode: "",
    isLoadingPage: false,
    searching: false,
    updating: false,
};
const leaveOverviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case leaveOverviewConstants.GET_OVERVIEW_LIST_SUCCESS:
            return {
                ...state,
                searching: false,
                listOverview: action.list,
                isLoadingPage: false,
            };
        case leaveOverviewConstants.GET_OVERVIEW_LIST:
            return {
                ...state,
                searching: true,
            };
        case leaveOverviewConstants.GET_OVERVIEW_LIST_PAGE:
            return {
                ...state,
                isLoadingPage: true,
            };
        case leaveOverviewConstants.UPDATE_OVERVIEW:
            return {
                ...state,
                updating: true,
            };
        case leaveOverviewConstants.UPDATE_OVERVIEW_SUCCESS:
            return {
                ...state,
                updating: false,
                successCode: CONSTANT.messageCode.success,
                listOverview: action.newList,
            };
        case leaveOverviewConstants.UPDATE_OVERVIEW_FAIL:
            return {
                ...state,
                updating: false,
                errorCode: action.error,
            };
        case leaveOverviewConstants.CLEAR_MESSAGE:
            return {
                ...state,
                errorCode: "",
                successCode: "",
            };
        default:
            return state;
    }
};

export default leaveOverviewReducer;
